import React, { useState } from 'react';
import HeaderBar from 'components/ui/HeaderBar';
import RoleBasedSidebar from 'components/ui/RoleBasedSidebar';
import BreadcrumbNavigation from 'components/ui/BreadcrumbNavigation';
import ChangePasswordForm from 'components/ui/ChangePasswordForm';
import { useAuth } from 'context/AuthContext';
import { getUserRoleForComponents } from 'utils/authHelpers';

const ClabSettings = () => {
  const { user, userProfile } = useAuth();
  const userRole = getUserRoleForComponents(user);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <HeaderBar 
        userRole={userRole} 
        userName={userProfile?.full_name || 'CLAB User'}
        onSidebarToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />
      <RoleBasedSidebar 
        userRole={userRole}
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <main className={`transition-all duration-300 pt-16 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
        <div className="p-6">
          <BreadcrumbNavigation userRole={userRole} />
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-text-primary mb-2">Settings</h1>
            <p className="text-text-secondary">Update your account preferences and change your password.</p>
          </div>
          <ChangePasswordForm />
        </div>
      </main>
    </div>
  );
};

export default ClabSettings;